import React, { useState, useEffect } from "react";
import {
  GoogleMap,
  withGoogleMap,
  Marker,
  DirectionsRenderer,
} from "react-google-maps";
import MarkerClusterer from "react-google-maps/lib/components/addons/MarkerClusterer";

// utils
import { mapStyles } from "../../utils";

// assets
import MarkerIcon from "src/assets/images/map-icon.png";
import UserLocIcon from "src/assets/images/user-loc-icon.png";

const Map = withGoogleMap(
  ({ events, handleClick, userCoords, direction, currentVisibleEvent }) => {
    const [currentCenter, setCurrentCenter] = useState({
      lat: Number(userCoords.lat),
      lng: Number(userCoords.lng),
    });

    const [currentZoom, setCurrentZoom] = useState(10);

    useEffect(() => {
      if (currentVisibleEvent) {
        setCurrentCenter(currentVisibleEvent.coords);
        setCurrentZoom(14);
      }
    }, [currentVisibleEvent]);

    const isCurrent = (_data) => {
      if (!currentVisibleEvent) return 1;

      if (_data.EventId === currentVisibleEvent.id) {
        return 1;
      } else {
        if (
          Number(_data.Latitude) === currentVisibleEvent.coords.lat &&
          Number(_data.Longitude) === currentVisibleEvent.coords.lng
        ) {
          return 0;
        } else {
          return 0.5;
        }
      }
    };

    return (
      <GoogleMap
        center={currentCenter}
        zoom={currentZoom}
        options={{
          keyboardShortcuts: false,
          disableDefaultUI: true,
          // styles: mapStyles,
        }}
      >
        <MarkerClusterer
          averageCenter
          enableRetinaIcons
          gridSize={120}
          maxZoom={13}
        >
          {events.map((item, i) => (
            <Marker
              key={i}
              position={{
                lat: Number(item.Latitude),
                lng: Number(item.Longitude),
              }}
              icon={MarkerIcon}
              animation={item.EventId === currentVisibleEvent?.id ? 1 : null}
              opacity={isCurrent(item)}
              onClick={() => handleClick(item)}
            />
          ))}
        </MarkerClusterer>
        <Marker
          position={{
            lat: Number(userCoords.lat),
            lng: Number(userCoords.lng),
          }}
          icon={UserLocIcon}
        />
        {direction && (
          <DirectionsRenderer
            directions={direction}
            options={{ suppressMarkers: true }}
          />
        )}
      </GoogleMap>
    );
  }
);

export default Map;
